import dayjs, { type Dayjs } from 'dayjs';

/**
 * pay_info_tran_date 등 MySQL에서 오는 값. `0000-00-00`은 dayjs가 1899-11-30으로 잘못 해석함 → 무효 처리.
 * 연도만 들어오는 숫자(레거시)는 목록에서는 전체 일자로 쓰지 않음.
 */
export function parsePayInfoDate(value: string | number | null | undefined): Dayjs | null {
	if (value == null || value === '') return null;
	if (typeof value === 'number') {
		if (Number.isInteger(value) && value >= 1900 && value <= 2100) {
			return null;
		}
		const d = dayjs(value);
		return d.isValid() && d.year() >= 1900 ? d : null;
	}
	const s = String(value).trim();
	if (s === '' || /^0000-00-00/.test(s)) return null;
	const d = dayjs(s);
	if (!d.isValid() || d.year() < 1900) return null;
	return d;
}

export function formatPayInfoRegisterListDate(item: {
	pay_info_tran_date?: string | number | null;
	pay_info_enrollment_date?: string | null;
}): string {
	const tran = parsePayInfoDate(item.pay_info_tran_date);
	if (tran) return tran.format('YYYY-MM-DD');
	const enroll = parsePayInfoDate(item.pay_info_enrollment_date);
	if (enroll) return enroll.format('YYYY-MM-DD');
	return '-';
}

// YYYY-MM-DD
export const formatDate = (date: Date | string) => {
	const d = new Date(date);
	return d
		.toLocaleDateString('ko-KR', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		})
		.replace(/\. /g, '-')
		.replace('.', '');
};

// YYYY-MM-DD HH:mm:ss
export const formatDateTime = (date: Date | string) => {
	const d = new Date(date);
	return `${formatDate(d)} ${d.toLocaleTimeString('ko-KR', {
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false,
	})}`;
};

// n일 전, n시간 전 등
export const getRelativeTime = (date: Date | string) => {
	const now = new Date();
	const diff = now.getTime() - new Date(date).getTime();

	const minutes = Math.floor(diff / (1000 * 60));
	const hours = Math.floor(diff / (1000 * 60 * 60));
	const days = Math.floor(diff / (1000 * 60 * 60 * 24));

	if (days > 0) return `${days}일 전`;
	if (hours > 0) return `${hours}시간 전`;
	if (minutes > 0) return `${minutes}분 전`;
	return '방금 전';
};
